module.exports = __webpack_public_path__ + "img/teachers.09aea164.png";